import { createContext } from 'react'

import type { ZaiChatContextData } from './types'

export const ZaiChatContext = createContext<ZaiChatContextData | null>(null)
